import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBadge,{attrs:{"inline":"","left":"","color":_vm.color,"dot":""}},[_vm._v("\n      "+_vm._s(_vm.representation)+"\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }